/**
 * Texts for Animations page - Polish
 *
 * VIDEO INSTRUCTIONS:
 * Visit https://www.youtube.com/@camdiab/videos
 * Replace VIDEO_ID with actual video IDs from the CamDiab channel
 */
export const animationsPageText = {
  title: "Animacje - CamAPS FX",
  titleMeta: "Animacje CamAPS FX - Przewodniki wizualne krok po kroku",
  descriptionMeta:
    "Obejrzyj krótkie animacje, które pomogą odpowiedzieć na kilka najczęstszych pytań CamDiab dotyczących korzystania z aplikacji CamAPS FX.",
  keywords:
    "animacje camaps fx, poradniki camaps, poradniki aplikacja diabetes, animacje pompa insulinowa, poradniki cgm",
  localeMeta: "pl_pl",

  mainHeader: "Animacje",
  mainSubHeader:
    "Krótkie animacje, które pomogą odpowiedzieć na kilka najczęstszych pytań CamDiab.",

  altHelp: "Pomoc",
  altInfo: "Informacja",
  altAppStore: "Pobierz z App Store",
  altGooglePlay: "Pobierz z Google Play",
  ariaGoToSlide: "Przejdź do slajdu {n}",
  ariaNextSlide: "Następny slajd",
  ariaPrevSlide: "Poprzedni slajd",
  videoNotSupportedText: "Twoja przeglądarka nie obsługuje znacznika wideo.",
  virtualModeTooltipText:
    "Tryb wirtualny pozwala wypróbować aplikację bez połączenia z prawdziwą pompą insulinową i sensorem CGM.",
  closeButtonText: "Zamknij",
  sortPopular: "Najpopularniejsze",
  sortAZ: "A-Z",
  sortOldest: "Najstarsze",
  sortNewest: "Najnowsze",
  filterDana: "Dana",
  filterYpsoPump: "YpsoPump",
  filterAll: "Wszystkie",
  // Getting Started Section
  gettingStartedHeader: "Gotowy, aby zacząć?",
  step1Title: "<strong>Krok 1:</strong> Pobierz aplikację",
  step2Title: "<strong>Krok 2:</strong> Utwórz konto",
  step3Title:
    "<strong>Krok 3:</strong> Rozpocznij podstawowe szkolenie w aplikacji",
  step4Title:
    "<strong>Krok 4:</strong> Sparuj wybran&aogon; pomp&eogon; i CGM (za zgod&aogon; swojego zespo&#322;u opieki zdrowotnej) lub zapoznaj si&eogon; z aplikacj&aogon; w <strong>Trybie Wirtualnym</strong>",

  // Support Section
  supportSectionTitle: "Potrzebujesz więcej pomocy?",
  supportSectionText:
    "Nasz zespół wsparcia jest tutaj, aby pomóc Ci w przypadku jakichkolwiek pytań.",
  supportButtonText: "SKONTAKTUJ SIĘ Z POMOCĄ",

  // Additional Resources Section
  additionalResourcesTitle: "Dodatkowe zasoby",
  additionalResourcesSubtitle: "Poznaj więcej sposobów na naukę o CamAPS FX",

  userTrainingTitle: "Szkolenie użytkowników",
  userTrainingDescription:
    "Kompleksowe materiały szkoleniowe, które pomogą Ci rozpocząć pracę z CamAPS FX.",
  userTrainingLink: "/user-training",

  webinarsTitle: "Webinary",
  webinarsDescription: "Dołącz do naszych webinarów na żywo i nagranych sesji.",
  webinarsLink: "#",

  factsheetsTitle: "Arkusze informacyjne",
  factsheetsDescription:
    "Pobierz przydatne arkusze informacyjne i przewodniki.",
  factsheetsLink: "#",

  videos: [
    // {
    //     id: 1,
    //     title: 'Getting Started with YpsoPump',
    //     description: 'Learn how to set up your YpsoPump with CamAPS FX.',
    //     date: '15 Dec 2024',
    //     duration: '5:24',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'ypso',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_1 with actual video ID from @camdiab channel
    //     views: 5420
    // },
    // {
    //     id: 2,
    //     title: 'Dana Pump Setup Guide',
    //     description: 'Step-by-step guide for Dana pump configuration.',
    //     date: '10 Dec 2024',
    //     duration: '7:15',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'dana',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_2 with actual video ID from @camdiab channel
    //     views: 8950
    // },
    // {
    //     id: 3,
    //     title: 'Understanding Your CGM Data',
    //     description: 'Learn how to interpret your glucose readings.',
    //     date: '5 Dec 2024',
    //     duration: '4:33',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'all',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_3 with actual video ID from @camdiab channel
    //     views: 12340
    // },
    // {
    //     id: 4,
    //     title: 'YpsoPump Advanced Features',
    //     description: 'Explore advanced settings and customization.',
    //     date: '1 Dec 2024',
    //     duration: '6:48',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'ypso',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_4 with actual video ID from @camdiab channel
    //     views: 3210
    // },
    // {
    //     id: 5,
    //     title: 'Dana Pump Troubleshooting',
    //     description: 'Common issues and solutions for Dana pump.',
    //     date: '28 Nov 2024',
    //     duration: '5:12',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'dana',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_5 with actual video ID from @camdiab channel
    //     views: 6780
    // },
    // {
    //     id: 6,
    //     title: 'Managing Meal Boluses',
    //     description: 'Best practices for meal-time insulin delivery.',
    //     date: '25 Nov 2024',
    //     duration: '8:05',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'all',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_6 with actual video ID from @camdiab channel
    //     views: 9450
    // },
    // {
    //     id: 7,
    //     title: 'YpsoPump Battery Management',
    //     description: 'Tips for extending battery life and replacement.',
    //     date: '20 Nov 2024',
    //     duration: '3:27',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'ypso',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_7 with actual video ID from @camdiab channel
    //     views: 4120
    // },
    // {
    //     id: 8,
    //     title: 'Dana Pump Cartridge Change',
    //     description: 'How to safely change your insulin cartridge.',
    //     date: '15 Nov 2024',
    //     duration: '4:55',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'dana',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_8 with actual video ID from @camdiab channel
    //     views: 7230
    // },
    // {
    //     id: 9,
    //     title: 'Exercise Mode Setup',
    //     description: 'Configure settings for physical activity.',
    //     date: '10 Nov 2024',
    //     duration: '6:18',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'all',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_9 with actual video ID from @camdiab channel
    //     views: 10560
    // },
    // {
    //     id: 10,
    //     title: 'YpsoPump Alerts & Notifications',
    //     description: 'Customize your pump alerts and alarms.',
    //     date: '5 Nov 2024',
    //     duration: '5:41',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'ypso',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_10 with actual video ID from @camdiab channel
    //     views: 5890
    // },
    // {
    //     id: 11,
    //     title: 'Dana Pump Connectivity',
    //     description: 'Bluetooth pairing and connection tips.',
    //     date: '1 Nov 2024',
    //     duration: '7:52',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'dana',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_11 with actual video ID from @camdiab channel
    //     views: 8120
    // },
    // {
    //     id: 12,
    //     title: 'Night Time Settings',
    //     description: 'Optimize your settings for better sleep.',
    //     date: "18 Apr 2016",
    //     duration: '6:03',
    //     thumbnail: '/images/video-placeholder.svg',
    //     category: 'all',
    //     videoUrl: 'https://www.youtube.com/watch?v=9xwazD5SyVg', // Replace VIDEO_ID_12 with actual video ID from @camdiab channel
    //     views: 11230
    // }
    // {
    //     "id": 1,
    //     "title": "Virtual Mode",
    //     "description": "Virtual Mode",
    //     "date": "15 Dec 2025",
    //     "duration": "1:30",
    //     "category": "all",
    //     "videoUrl": "https://youtu.be/PUXDc5nXcaU",
    //     "views": 500
    // },
    // {
    //     "id": 2,
    //     "title": "Travelling with CamAPS FX - YpsoPump users",
    //     "description": "Travelling with CamAPS FX - YpsoPump users",
    //     "date": "12 Dec 2025",
    //     "duration": "2:49",
    //     "category": "YpsoPump ",
    //     "videoUrl": "https://youtu.be/unUO7daCp3c",
    //     "views": 31000
    // },
    // {
    //     "id": 3,
    //     "title": "Travelling with CamAPS FX - Dana users",
    //     "description": "Travelling with CamAPS FX - Dana users",
    //     "date": "12 Dec 2025",
    //     "duration": "2:50",
    //     "category": "Dana ",
    //     "videoUrl": "https://youtu.be/GplwuTfOGv8",
    //     "views": 30900
    // },
    // {
    //     "id": 4,
    //     "title": "Understanding Highs and Lows - Dana users",
    //     "description": "Understanding Highs and Lows - Dana users",
    //     "date": "12 Dec 2025",
    //     "duration": "4:55",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/mR_wO0BM9mM",
    //     "views": 29900
    // },
    // {
    //     "id": 5,
    //     "title": "Understanding Highs and Lows - YpsoPump users (mmol/L)",
    //     "description": "Understanding Highs and Lows - YpsoPump users (mmol/L)",
    //     "date": "12 Dec 2025",
    //     "duration": "4:55",
    //     "category": "YpsoPump ",
    //     "videoUrl": "https://youtu.be/Y0dhj7hvXgM",
    //     "views": 30000
    // },
    // {
    //     "id": 6,
    //     "title": "Understanding Highs and Lows - YpsoPump users (mg/dL)",
    //     "description": "Understanding Highs and Lows - YpsoPump users (mg/dL)",
    //     "date": "12 Dec 2025",
    //     "duration": "4:55",
    //     "category": "YpsoPump ",
    //     "videoUrl": "https://youtu.be/rr6oytHLT74",
    //     "views": 29000
    // },
    // {
    //     "id": 7,
    //     "title": "CamAPS FX's MealAssist",
    //     "description": "CamAPS FX's MealAssist",
    //     "date": "3 Dec 2025",
    //     "duration": "1:36",
    //     "category": "all",
    //     "videoUrl": "https://youtu.be/On-YDive00w",
    //     "views": 400
    // },
    // {
    //     "id": 8,
    //     "title": "Using CamAPS FX when pregnant - Dana users",
    //     "description": "Using CamAPS FX when pregnant - Dana users",
    //     "date": "17 Feb 2026",
    //     "duration": "6:41",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/DrGDN-0iwrA",
    //     "views": 32900
    // },
    // {
    //     "id": 9,
    //     "title": "Using CamAPS FX when pregnant - YpsoPump users (mg/dL)",
    //     "description": "Using CamAPS FX when pregnant - YpsoPump users (mg/dL)",
    //     "date": "17 Feb 2026",
    //     "duration": "6:47",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/AM4MBXNtsSQ",
    //     "views": 32000
    // },
    // {
    //     "id": 10,
    //     "title": "Using CamAPS FX when pregnant - YpsoPump users (mmol/L)",
    //     "description": "Using CamAPS FX when pregnant - YpsoPump users (mmol/L)",
    //     "date": "17 Feb 2026",
    //     "duration": "6:42",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/F0CwAzxgOps",
    //     "views": 33000
    // },
    // {
    //     "id": 11,
    //     "title": "Body weight - Dana users",
    //     "description": "Body weight - Dana users",
    //     "date": "17 Feb 2026",
    //     "duration": "1:10",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/MPL14Y6f4QI",
    //     "views": 23900
    // },
    // {
    //     "id": 12,
    //     "title": "Body weight - YpsoPump users",
    //     "description": "Body weight - YpsoPump users",
    //     "date": "17 Feb 2026",
    //     "duration": "1:10",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/JIVtrzBmQ2w",
    //     "views": 24000
    // },
    // {
    //     "id": 13,
    //     "title": "Total Daily Dose (TDD) - Dana users",
    //     "description": "Total Daily Dose (TDD) - Dana users",
    //     "date": "17 Feb 2026",
    //     "duration": "1:13",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/2cFsVmXuJSk",
    //     "views": 22900
    // },
    // {
    //     "id": 14,
    //     "title": "Total Daily Dose (TDD) - YpsoPump users",
    //     "description": "Total Daily Dose (TDD) - YpsoPump users",
    //     "date": "17 Feb 2026",
    //     "duration": "1:13",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/yxz0nnAhM5E",
    //     "views": 23000
    // },
    // {
    //     "id": 15,
    //     "title": "CamAPS Companion - YpsoPump user",
    //     "description": "CamAPS Companion - YpsoPump user",
    //     "date": "8 Sep 2025",
    //     "duration": "2:50",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/L3Vla5ktT_o",
    //     "views": 6000
    // },
    // {
    //     "id": 16,
    //     "title": "CamAPS Companion - Dana user",
    //     "description": "CamAPS Companion - Dana user",
    //     "date": "3 May 2024",
    //     "duration": "3:36",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/tV8I5Bnnsqg",
    //     "views": 5900
    // },
    // {
    //     "id": 17,
    //     "title": "Sharing diabetes data - iOS app & YpsoPump user",
    //     "description": "Sharing diabetes data - iOS app & YpsoPump user",
    //     "date": "8 Sep 2025",
    //     "duration": "2:14",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/NUH6TG2QMYs",
    //     "views": 7000
    // },
    // {
    //     "id": 18,
    //     "title": "Sharing diabetes data - Android app & YpsoPump user",
    //     "description": "Sharing diabetes data - Android app & YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "2:50",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/CRUhDMep1II",
    //     "views": 8000
    // },
    // {
    //     "id": 19,
    //     "title": "Sharing diabetes data - Dana user",
    //     "description": "Sharing diabetes data - Dana user",
    //     "date": "2 Nov 2023",
    //     "duration": "2:38",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/PRbRk1wUwXQ",
    //     "views": 7900
    // },
    // {
    //     "id": 20,
    //     "title": "What is a patency pulse? - YpsoPump user (mg/dL)",
    //     "description": "What is a patency pulse? - YpsoPump user (mg/dL)",
    //     "date": "20 May 2025",
    //     "duration": "2:55",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/EhOrwkhINT8",
    //     "views": 300
    // },
    // {
    //     "id": 21,
    //     "title": "What is a patency pulse? - YpsoPump user (mmol/L)",
    //     "description": "What is a patency pulse? - YpsoPump user (mmol/L)",
    //     "date": "20 May 2025",
    //     "duration": "2:57",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/0JHBcLS1QOU",
    //     "views": 200
    // },
    // {
    //     "id": 22,
    //     "title": "Using Ease-off - YpsoPump user",
    //     "description": "Using Ease-off - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "3:23",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/jP9CUI8QGJI",
    //     "views": 15000
    // },
    // {
    //     "id": 23,
    //     "title": "Using Ease-off - Dana users",
    //     "description": "Using Ease-off - Dana users",
    //     "date": "28 Aug 2023",
    //     "duration": "3:08",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/YeMcKxD5JGs",
    //     "views": 14900
    // },
    // {
    //     "id": 24,
    //     "title": "Using Boost - YpsoPump user",
    //     "description": "Using Boost - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "2:04",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/ySNNpOLEbDM",
    //     "views": 14000
    // },
    // {
    //     "id": 25,
    //     "title": "Using Boost - Dana user",
    //     "description": "Using Boost - Dana user",
    //     "date": "17 Aug 2023",
    //     "duration": "2:40",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/YXIymSzb4Fc",
    //     "views": 13900
    // },
    // {
    //     "id": 26,
    //     "title": "Using Block - YpsoPump user",
    //     "description": "Using Block - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "1:14",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/NQD3dGuLfiQ",
    //     "views": 5000
    // },
    // {
    //     "id": 27,
    //     "title": "Using Block - Dana user",
    //     "description": "Using Block - Dana user",
    //     "date": "17 Oct 2023",
    //     "duration": "1:51",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/6UE-bD8ULX0",
    //     "views": 4900
    // },
    // {
    //     "id": 28,
    //     "title": "Using Auto mode - YpsoPump user",
    //     "description": "Using Auto mode - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "2:47",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/LJ_1CkYmFrM",
    //     "views": 18000
    // },
    // {
    //     "id": 29,
    //     "title": "Using Auto mode - Dana user",
    //     "description": "Using Auto mode - Dana user",
    //     "date": "15 Feb 2024",
    //     "duration": "2:03",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/KcWwqxb45-I",
    //     "views": 17900
    // },
    // {
    //     "id": 30,
    //     "title": "Using Add meal - YpsoPump user",
    //     "description": "Using Add meal - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "3:54",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/9d59XSZMHc8",
    //     "views": 16000
    // },
    // {
    //     "id": 31,
    //     "title": "Using Add meal - Dana user",
    //     "description": "Using Add meal - Dana user",
    //     "date": "16 Oct 2023",
    //     "duration": "3:34",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/LsTOdu20dww",
    //     "views": 15900
    // },
    // {
    //     "id": 32,
    //     "title": "Top technical tips - iOS app & YpsoPump user",
    //     "description": "Top technical tips - iOS app & YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "3:18",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/0gFg2eIHhFw",
    //     "views": 27000
    // },
    // {
    //     "id": 33,
    //     "title": "Top technical tips - Android app & YpsoPump user",
    //     "description": "Top technical tips - Android app & YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "3:21",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/CTmkjItioRs",
    //     "views": 28000
    // },
    // {
    //     "id": 34,
    //     "title": "Top technical tips - Dana user",
    //     "description": "Top technical tips - Dana user",
    //     "date": "28 Nov 2023",
    //     "duration": "3:14",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/lP9jKnyA0Gw",
    //     "views": 27900
    // },
    // {
    //     "id": 35,
    //     "title": "Setting up the Personal Glucose Target - YpsoPump user (mmol/L)",
    //     "description": "Setting up the Personal Glucose Target - YpsoPump user (mmol/L)",
    //     "date": "20 May 2025",
    //     "duration": "2:19",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/qcL_WML_CWg",
    //     "views": 20000
    // },
    // {
    //     "id": 36,
    //     "title": "Setting up the Personal Glucose Target - Dana user",
    //     "description": "Setting up the Personal Glucose Target - Dana user",
    //     "date": "17 Oct 2023",
    //     "duration": "1:57",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/w__3sQjxT7o",
    //     "views": 19900
    // },
    // {
    //     "id": 37,
    //     "title": "Setting up the Personal Glucose Target - YpsoPump user (mg/dL)",
    //     "description": "Setting up the Personal Glucose Target - YpsoPump user (mg/dL)",
    //     "date": "20 May 2025",
    //     "duration": "2:20",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/1Wn39EVOloo",
    //     "views": 19000
    // },
    // {
    //     "id": 38,
    //     "title": "Setting up the bolus calculator - YpsoPump user (mmol/L)",
    //     "description": "Setting up the bolus calculator - YpsoPump user (mmol/L)",
    //     "date": "17 Feb 2026",
    //     "duration": "3:49",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/3xGnCbaVyXE",
    //     "views": 22000
    // },
    // {
    //     "id": 39,
    //     "title": "Setting up the bolus calculator - YpsoPump user (mg/dL)",
    //     "description": "Setting up the bolus calculator - YpsoPump user (mg/dL)",
    //     "date": "17 Feb 2026",
    //     "duration": "3:44",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/KfROo8PfoQc",
    //     "views": 21000
    // },
    // {
    //     "id": 40,
    //     "title": "Setting up the bolus calculator - Dana insulin pump user",
    //     "description": "Setting up the bolus calculator - Dana insulin pump user",
    //     "date": "17 Feb 2026",
    //     "duration": "2:34",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/HhwVwm9nlPU",
    //     "views": 21900
    // },
    // {
    //     "id": 41,
    //     "title": "Setting alerts - iOS app & YpsoPump user (mg/dL)",
    //     "description": "Setting alerts - iOS app & YpsoPump user (mg/dL)",
    //     "date": "20 May 2025",
    //     "duration": "2:33",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/--kZle0n5G8",
    //     "views": 9000
    // },
    // {
    //     "id": 42,
    //     "title": "Setting alerts - iOS app & YpsoPump user (mmol/L)",
    //     "description": "Setting alerts - iOS app & YpsoPump user (mmol/L)",
    //     "date": "20 May 2025",
    //     "duration": "2:34",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/WMHrdVb9BCE",
    //     "views": 10000
    // },
    // {
    //     "id": 43,
    //     "title": "Setting alerts - Android app & YpsoPump user (mg/dL)",
    //     "description": "Setting alerts - Android app & YpsoPump user (mg/dL)",
    //     "date": "20 May 2025",
    //     "duration": "2:35",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/FGBIJeYlGb0",
    //     "views": 11000
    // },
    // {
    //     "id": 44,
    //     "title": "Setting alerts - Android app & YpsoPump user (mmol/L)",
    //     "description": "Setting alerts - Android app & YpsoPump user (mmol/L)",
    //     "date": "20 May 2025",
    //     "duration": "2:40",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/qL9lX1D7lFE",
    //     "views": 12000
    // },
    // {
    //     "id": 45,
    //     "title": "Setting alerts - Dana user",
    //     "description": "Setting alerts - Dana user",
    //     "date": "19 Sep 2023",
    //     "duration": "2:35",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/rqrEwH0N0kc",
    //     "views": 8900
    // },
    // {
    //     "id": 46,
    //     "title": "Pairing pump and sensor - YpsoPump user",
    //     "description": "Pairing pump and sensor - YpsoPump user",
    //     "date": "17 Feb 2026",
    //     "duration": "1:36",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/u2qDc7I7ZXg",
    //     "views": 25000
    // },
    // {
    //     "id": 47,
    //     "title": "Pairing pump and sensor - Dana user",
    //     "description": "Pairing pump and sensor - Dana user",
    //     "date": "17 Feb 2026",
    //     "duration": "1:30",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/FpJ9ys5w4jY",
    //     "views": 24900
    // },
    // {
    //     "id": 48,
    //     "title": "Navigating the app - YpsoPump user",
    //     "description": "Navigating the app - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "2:55",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/3FTZUfn6rrw",
    //     "views": 26000
    // },
    // {
    //     "id": 49,
    //     "title": "Navigating the app - Dana user",
    //     "description": "Navigating the app - Dana user",
    //     "date": "19 Sep 2023",
    //     "duration": "2:55",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/wSo-12s_JlM",
    //     "views": 25900
    // },
    // {
    //     "id": 50,
    //     "title": "Giving a meal bolus - YpsoPump user",
    //     "description": "Giving a meal bolus - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "1:05",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/isrdKtwpJqI",
    //     "views": 17000
    // },
    // {
    //     "id": 51,
    //     "title": "Giving a meal bolus - Dana user",
    //     "description": "Giving a meal bolus - Dana user",
    //     "date": "17 Oct 2023",
    //     "duration": "1:56",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/Wk_9mgaFVCY",
    //     "views": 16900
    // },
    // {
    //     "id": 52,
    //     "title": "Giving a manual correction - YpsoPump user",
    //     "description": "Giving a manual correction - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "1:46",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/ZabVlmn8ELM",
    //     "views": 13000
    // },
    // {
    //     "id": 53,
    //     "title": "Giving a manual correction - Dana user",
    //     "description": "Giving a manual correction - Dana user",
    //     "date": "13 Sep 2023",
    //     "duration": "1:55",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/G0R6tIU8N3w",
    //     "views": 12900
    // },
    // {
    //     "id": 54,
    //     "title": "Changing carbohydrate units - YpsoPump user",
    //     "description": "Changing carbohydrate units - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "0:52",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/K0LrmfdIHpE",
    //     "views": 2000
    // },
    // {
    //     "id": 55,
    //     "title": "Changing carbohydrate units - Dana user",
    //     "description": "Changing carbohydrate units - Dana user",
    //     "date": "2 Nov 2023",
    //     "duration": "0:46",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/cCdBBbBY9MY",
    //     "views": 1900
    // },
    // {
    //     "id": 56,
    //     "title": "Calibrating the sensor - YpsoPump user",
    //     "description": "Calibrating the sensor - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "2:24",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/9sRFDE1kiGk",
    //     "views": 3000
    // },
    // {
    //     "id": 57,
    //     "title": "Calibrating the sensor - Dana user",
    //     "description": "Calibrating the sensor - Dana user",
    //     "date": "19 Sep 2023",
    //     "duration": "2:09",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/uA0qNL2LZx4",
    //     "views": 2900
    // },
    // {
    //     "id": 58,
    //     "title": "Adjusting meal sizes - YpsoPump user",
    //     "description": "Adjusting meal sizes - YpsoPump user",
    //     "date": "20 May 2025",
    //     "duration": "0:37",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/Iw5GypH_WzQ",
    //     "views": 4000
    // },
    // {
    //     "id": 59,
    //     "title": "Adjusting meal sizes - Dana user",
    //     "description": "Adjusting meal sizes - Dana user",
    //     "date": "2 Nov 2023",
    //     "duration": "0:57",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/Daf5tnKOIUE",
    //     "views": 3900
    // },
    // {
    //     "id": 60,
    //     "title": "Managing physical activity - YpsoPump user",
    //     "description": "Managing physical activity - YpsoPump user",
    //     "date": "25 Apr 2025",
    //     "duration": "6:15",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/XmGnI19zCCg",
    //     "views": 34000
    // },
    // {
    //     "id": 61,
    //     "title": "Managing physical activity - Dana user",
    //     "description": "Managing physical activity - Dana user",
    //     "date": "25 Apr 2025",
    //     "duration": "6:15",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/XmGnI19zCCg",
    //     "views": 33900
    // },
    // {
    //     "id": 62,
    //     "title": "How does CamAPS FX drive insulin delivery? - YpsoPump user",
    //     "description": "How does CamAPS FX drive insulin delivery? - YpsoPump user",
    //     "date": "7 Sep 2023",
    //     "duration": "3:22",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/PtK0FBBDajM",
    //     "views": 35000
    // },
    // {
    //     "id": 63,
    //     "title": "How does CamAPS FX drive insulin delivery? - Dana user",
    //     "description": "How does CamAPS FX drive insulin delivery? - Dana user",
    //     "date": "3 Aug 2023",
    //     "duration": "3:21",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/fF_UZxZOJ3w",
    //     "views": 34900
    // },
    // {
    //     "id": 64,
    //     "title": "How does CamAPS FX learn? - YpsoPump user",
    //     "description": "How does CamAPS FX learn? - YpsoPump user",
    //     "date": "7 Sep 2023",
    //     "duration": "4:15",
    //     "category": "ypso",
    //     "videoUrl": "https://youtu.be/98X3X9ie8uM",
    //     "views": 36000
    // },
    // {
    //     "id": 65,
    //     "title": "How does CamAPS FX learn? - Dana user",
    //     "description": "How does CamAPS FX learn? - Dana user",
    //     "date": "1 Sep 2023",
    //     "duration": "4:14",
    //     "category": "dana",
    //     "videoUrl": "https://youtu.be/-YQWyAr-GQ0",
    //     "views": 35900
    // },
    {
      id: 1,
      title: "Dostosowywanie ustawionych wielkosci positków",
      description: "Dostosowywanie ustawionych wielkosci positków",
      date: "30 Apr 2025",
      duration: "0:47",
      category: "ypso",
      videoUrl: "https://youtu.be/G_Pc7ocMD3M",
    },
    {
      id: 2,
      title: "Kalibracja czujnika",
      description: "Kalibracja czujnika",
      date: "30 Apr 2025",
      duration: "2:07",
      category: "ypso",
      videoUrl: "https://youtu.be/5VjScLr_Ly4",
    },
    {
      id: 3,
      title: "CamAPS Companion",
      description: "CamAPS Companion",
      date: "8 Sep 2025",
      duration: "3:12",
      category: "ypso",
      videoUrl: "https://youtu.be/mVzWANT-I_E",
    },
    {
      id: 4,
      title: "CamAPS Liberty",
      description: "CamAPS Liberty",
      date: "18 Aug 2026",
      duration: "3:27",
      category: "ypso",
      videoUrl: "https://youtu.be/cPjMSqLUgVs",
    },
    {
      id: 5,
      title: "Zmiana Jednostek Weglowodanów",
      description: "Zmiana Jednostek Weglowodanów",
      date: "30 Apr 2025",
      duration: "1:00",
      category: "ypso",
      videoUrl: "https://youtu.be/4K09yDPxDnY",
    },
    {
      id: 6,
      title: "Masa ciata",
      description: "Masa ciata",
      date: "3 Mar 2026",
      duration: "1:25",
      category: "ypso",
      videoUrl: "https://youtu.be/GXJp9qwq3Ss",
    },
    {
      id: 7,
      title: "Catkowita Dawka Dobowa Insuliny - TDD",
      description: "Catkowita Dawka Dobowa Insuliny - TDD",
      date: "3 Mar 2026",
      duration: "1:30",
      category: "ypso",
      videoUrl: "https://youtu.be/xPhVx38pRUE",
    },
    {
      id: 8,
      title: "Podanie bolusa korekcyjnego",
      description: "Podanie bolusa korekcyjnego",
      date: "30 Apr 2025",
      duration: "2:13",
      category: "ypso",
      videoUrl: "https://youtu.be/l50x2RNbFrU",
    },
    {
      id: 9,
      title: "Podanie bolusa posiłkowego",
      description: "Podanie bolusa posiłkowego",
      date: "12 Oct 2026",
      duration: "1:06",
      category: "ypso",
      videoUrl: "https://youtu.be/FcDGPmJNol8",
    },
    {
      id: 10,
      title: "Jak CamAPS FX steruje podawaniem insuliny?",
      description: "Jak CamAPS FX steruje podawaniem insuliny?",
      date: "30 Apr 2025",
      duration: "4:15",
      category: "ypso",
      videoUrl: "https://youtu.be/lqZdeucqaSw",
    },
    {
      id: 11,
      title: "Jak CamAPS FX sie uczy?",
      description: "Jak CamAPS FX sie uczy?",
      date: "30 Apr 2025",
      duration: "5:34",
      category: "ypso",
      videoUrl: "https://youtu.be/bpyIcixXRqs",
    },
    {
      id: 12,
      title: "Zarzadzanie aktywnoscia fizyczna",
      description: "Zarzadzanie aktywnoscia fizyczna",
      date: "11 Aug 2025",
      duration: "7:16",
      category: "ypso",
      videoUrl: "https://youtu.be/YYbXy-DsFu0",
    },
    {
      id: 13,
      title: "Nawigacja w aplikacji",
      description: "Nawigacja w aplikacji",
      date: "12 Oct 2026",
      duration: "3:40",
      category: "ypso",
      videoUrl: "https://youtu.be/ZZ4pJ9Hz7js",
    },
    {
      id: 14,
      title: "Parowanie pompy i sensora",
      description: "Parowanie pompy i sensora",
      date: "3 Mar 2026",
      duration: "1:43",
      category: "ypso",
      videoUrl: "https://youtu.be/EWWtkCUDNEg",
    },
    {
      id: 15,
      title: "Ustawianie Powiadomien - iOS",
      description: "Ustawianie Powiadomien - iOS",
      date: "20 May 2025",
      duration: "3:22",
      category: "ypso",
      videoUrl: "https://youtu.be/yTM4W1X-C80",
    },
    {
      id: 16,
      title: "Ustawianie Powiadomien - Android",
      description: "Ustawianie Powiadomien - Android",
      date: "30 Apr 2025",
      duration: "3:30",
      category: "ypso",
      videoUrl: "https://youtu.be/7bK90TAISSU",
    },
    {
      id: 17,
      title: "Konfigurowanie kalkulatora bolusa",
      description: "Konfigurowanie kalkulatora bolusa",
      date: "12 Oct 2026",
      duration: "4:25",
      category: "ypso",
      videoUrl: "https://youtu.be/2nk-TGOwRoI",
    },
    {
      id: 18,
      title: "Ustawianie osobistej docelowej glikemii",
      description: "Ustawianie osobistej docelowej glikemii",
      date: "30 Apr 2025",
      duration: "2:38",
      category: "ypso",
      videoUrl: "https://youtu.be/zBYj7CTK4mM",
    },
    {
      id: 19,
      title: "Udostepnianie danych dotyczacych cukrzycy - iOS",
      description: "Udostepnianie danych dotyczacych cukrzycy - iOS",
      date: "8 Sep 2025",
      duration: "2:41",
      category: "ypso",
      videoUrl: "https://youtu.be/6ZLgREHtAOw",
    },
    {
      id: 20,
      title: "Udostepnianie danych dotyczacych cukrzycy - Android",
      description: "Udostepnianie danych dotyczacych cukrzycy - Android",
      date: "30 Apr 2025",
      duration: "3:22",
      category: "ypso",
      videoUrl: "https://youtu.be/ZOagHgq8P6M",
    },
    {
      id: 21,
      title: "Najwazniejsze porady dotyczace rozwiazywania problemów - iOS",
      description:
        "Najwazniejsze porady dotyczace rozwiazywania problemów - iOS",
      date: "30 Apr 2025",
      duration: "3:39",
      category: "ypso",
      videoUrl: "https://youtu.be/5lfscmucfTM",
    },
    {
      id: 22,
      title: "Najwazniejsze porady dotyczace rozwiazywania problemów - Android",
      description:
        "Najwazniejsze porady dotyczace rozwiazywania problemów - Android",
      date: "30 Apr 2025",
      duration: "3:47",
      category: "ypso",
      videoUrl: "https://youtu.be/I8uawsqMQvg",
    },
    {
      id: 23,
      title: "Uzywanie Dodaj positek",
      description: "Uzywanie Dodaj positek",
      date: "30 Apr 2025",
      duration: "4:52",
      category: "ypso",
      videoUrl: "https://youtu.be/cF826pDQhP4",
    },
    {
      id: 24,
      title: "Korzystając z trybu Auto mode",
      description: "Korzystając z trybu Auto mode",
      date: "12 Oct 2026",
      duration: "3:18",
      category: "ypso",
      videoUrl: "https://youtu.be/fUt5i6sgLyw",
    },
    {
      id: 25,
      title: "Uzywanie trybu Blokuj",
      description: "Uzywanie trybu Blokuj",
      date: "30 Apr 2025",
      duration: "1:49",
      category: "ypso",
      videoUrl: "https://youtu.be/Cb9-YBLyNys",
    },
    {
      id: 26,
      title: "Uzywanie trybu Boost",
      description: "Uzywanie trybu Boost",
      date: "26 Feb 2026",
      duration: "2:33",
      category: "ypso",
      videoUrl: "https://youtu.be/0sFPUGAglu8",
    },
    {
      id: 27,
      title: "Korzystanie z trybu Ease-off",
      description: "Korzystanie z trybu Ease-off",
      date: "30 Apr 2025",
      duration: "3:55",
      category: "ypso",
      videoUrl: "https://youtu.be/DxWRK6145AI",
    },
    {
      id: 28,
      title: "Co to jest podtrzymywanie droznosci drenu?",
      description: "Co to jest podtrzymywanie droznosci drenu?",
      date: "30 Apr 2025",
      duration: "3:39",
      category: "ypso",
      videoUrl: "https://youtu.be/SlCIUuvcrm4",
    },
    {
      id: 29,
      title: "Podróżowanie z CamAPS FX",
      description: "Podróżowanie z CamAPS FX",
      date: "12 Oct 2026",
      duration: "3:15",
      category: "ypso",
      videoUrl: "https://youtu.be/UjoNbZa0cto",
    },
    {
      id: 30,
      title: "Korzystanie z CamAPS FX w czasie ciąży",
      description: "Korzystanie z CamAPS FX w czasie ciąży",
      date: "12 Oct 2026",
      duration: "7:11",
      category: "ypso",
      videoUrl: "https://youtu.be/6nysvpqASlg",
    },
    {
      id: 31,
      title: "Zrozumienie wysokiego i niskiego poziomu glukozy",
      description: "Zrozumienie wysokiego i niskiego poziomu glukozy",
      date: "12 Oct 2026",
      duration: "5:38",
      category: "ypso",
      videoUrl: "https://youtu.be/EXtLx5dRpIY",
    },
    {
      id: 32,
      title: "Wskazówki: CamAPS Liberty",
      description: "Wskazówki: CamAPS Liberty",
      date: "2 Nov 2026",
      duration: "2:11",
      category: "ypso",
      videoUrl: "https://youtu.be/_d6fwzT0jSc",
    },
  ],
};
